import * as types from './constants';

// Get Promotion
export const getPromotionRequest = data => (
  { type: types.GET_PROMOTION_REQUEST, payload: data }
);

export const getPromotionDone = data => (
  { type: types.GET_PROMOTION_DONE, payload: data }
);

export const getPromotionFailed = errors => (
  { type: types.GET_PROMOTION_FAILED, payload: errors }
);

// Update Promotion
export const updatePromotionRequest = data => (
  { type: types.UPDATE_PROMOTION_REQUEST, payload: data }
);

export const updatePromotionDone = data => (
  { type: types.UPDATE_PROMOTION_DONE, payload: data }
);

export const updatePromotionFailed = errors => (
  { type: types.UPDATE_PROMOTION_FAILED, payload: errors }
);

export const updatePromotionReset = () => (
  { type: types.UPDATE_PROMOTION_RESET }
);